
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.834 7.5c-.709 0-1.302-.24-1.782-.719-.479-.479-.718-1.073-.718-1.781s.24-1.302.718-1.781c.48-.48 1.073-.72 1.782-.72.708 0 1.302.24 1.78.72.48.479.72 1.073.72 1.78 0 .71-.24 1.303-.72 1.782-.478.48-1.072.719-1.78.719zM6.5 9.167L5.334 7.979l2.145-2.146H.667V4.167h6.812L5.334 2 6.5.833 10.667 5 6.5 9.167z"}})])
          )
        }
      }
    